module.exports = __webpack_public_path__ + "img/clock-rotate-left-orange.d9a3e57b.svg";